import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { CodeBlock } from '../components/blocks/CodeBlock';

export const isCodeBlock = isElementType(CodeBlock);
